import apis from '@/libs/base/apis';

export function getTp(url) {
  let tp = '';
  switch (url) {
    case apis.blessv1_wpay: // 祝福老版
    case apis.blessv4_wpay: // 祝福新版
      tp = 1;
      break;
    case apis.photov1_wpay: // 发照片老版
    case apis.photov2_wpay: // 发照片新版
      tp = 2;
      break;
    case apis.vipPay: // 开通VIP
    case apis.vipExperiment: // 体验VIP
      tp = 3;
      break;
    case apis.baochang_wpay: // 包场
      tp = 4;
      break;
  }
  return tp;
}
